import styled from 'styled-components';
import { CharacteristicsStyled } from '../CharacteristicsStyled';
import { rem } from 'polished';
import { breakpoints } from '../../../../styles/theme';

export const CharacteristicsStyledAC = styled(CharacteristicsStyled)`
    .title {
        font-size: ${rem(24)};
        padding-bottom: ${rem(15)};
        color: ${({ theme }) => theme.colors.grey5};

        @media (min-width: ${breakpoints.sm}px) {
            font-size: ${rem(34)};
        }
    }

    .subTitle {
        font-size: ${rem(22)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        color: ${({ theme }) => theme.colors.grey5};
    }

    .sectionTitle {
        font-size: ${rem(18)};
        text-transform: uppercase;
        display: block;
        color: ${({ theme }) => theme.colors.grey5};
        margin-top: ${rem(40)};
    }

    .sectionSubTitle {
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.grey5};
        font-size: ${rem(16)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};

        svg {
            width: ${rem(18)};
            height: ${rem(18)};

            path {
                fill: ${({ theme }) => theme.colors.grey5};
            }
        }
    }

    .primaryTechs {
        background: ${({ theme }) => theme.colors.grey8};
        border-radius: ${rem(8)};
        font-size: ${rem(16)};
    }

    .secondaryTechs {
        font-size: ${rem(16)};
    }

    .detailTechs {
        font-size: ${rem(16)};
    }

    .characteristicsTechs {
        font-size: ${rem(16)};
    }

    .legalText {
        margin-top: ${rem(45)};
        font-size: ${rem(12)};
        color: ${({ theme }) => theme.colors.grey2};

        a {
            color: ${({ theme }) => theme.colors.blue2};
            padding-left: ${rem(4)};
        }
    }
`;
